import React, {useContext} from "react";

import pi_pending from "../../../Images/bureauImages/pi_pending.png";
import bank_statement from "../../../Images/bureauImages/bank_statement.png";
import final_offer from "../../../Images/bureauImages/final_offer.png";
import bulb from "../../../Images/bureauImages/bulb.png";
import handshake from "../../../Images/bureauImages/handshake.png";
import logo from '../../../Images/helloTradeImages/HelloTradeLogo.png'
import rupeeIcon from '../../../Images/helloTradeImages/RupeeIcon.png'
import { BureauContext } from '../../Pages/HelloTradePage';

function SideBarComponent() {
    const {displayPage} = useContext(BureauContext);

    return (
        <>
        <div className="leftPanel-parent">
            <div className="leftPanel">
                <div className='header logo bureauHeader' style={{marginLeft:'0px'}}>
                    <img src={rupeeIcon} id="rupeeIcon" />
                    <img src={logo} id="logoIcon" />
                </div>
            {/* <div className="loanJourneyText">Your Loan Journey</div> */}

            <div className="headerDivs" style={{ marginTop: "32px" }}>
                <div className="journeyImg">
                <div className={`vertical-line ${displayPage > 1 ? 'lineComp' : ''}`}></div>
                {
                    displayPage == 1 &&
                    <div className="journeyNotComp commonJourney">1</div>
                }
                {
                    displayPage != 1 &&
                    <div className="journeyComp commonJourney"><i class="bi bi-check2"></i></div>
                }
                </div>
                <div style={{ marginBottom: "9px" }}>
                <div className="panelHeading">Personal Information</div>
                <div className="panelContent">Name, PAN, Mobile Number</div>
                </div>
            </div>

            <div className="headerDivs" style={{ marginTop: "51px" }}>
                <div className="journeyImg" style={{ maxHeight: "40px" }}>
                <div className={`vertical-line ${displayPage > 3 ? 'lineComp' : ''}`}></div>
                {
                    displayPage == 3 &&
                    <div className="journeyComp commonJourney">2</div>
                }
                {
                    displayPage > 3 &&
                    <div className="journeyComp commonJourney"><i class="bi bi-check2"></i></div>
                }
                {
                    displayPage < 3 &&
                    <div className="journeyNotComp commonJourney">2</div>
                }
                </div>
                <div>

                {/* {displayPage} */}
                <div className="panelHeading">Upload Bank Statement</div>
                <div className="panelContent">Bank Account Details</div>
                </div>
            </div>

            <div className="headerDivs" style={{ marginTop: "70px" }}>
                <div className="journeyImg">
                {
                    displayPage == 4 &&
                    <div className="journeyComp commonJourney">3</div>
                }
                {
                    displayPage != 4 &&
                    <div className="journeyNotComp commonJourney">3</div>
                }
                </div>
                <div>
                <div className="panelHeading">Get Final Offer</div>
                <div className="panelContent">Get Offers from Lenders</div>
                </div>
            </div>

            <div className="leftDiv">
                <div>
                <img src={handshake} alt="handshake-icon" style={{ width: "26px" }} />
                </div>
                <div className="leftText">
                    <div style={{color:'#00B2A4'}}>Secure, Simple, Reliable</div>
                Trusted by Millions. We keep your documents confidential.
                </div>
            </div>
            </div>
        </div>
        </>
    );
}

export default SideBarComponent;